import axios from 'axios';

async function me(): Promise<unknown> {
    const results = await axios.get(`/api/profiles/me`);
    return results.data;
}

async function update(profile: unknown): Promise<unknown> {
    const results = await axios.put(`/api/profiles`, profile);
    return results.data;
}

async function get(id: string): Promise<unknown> {
    const results = await axios.get(`/api/profiles/${id}`);
    return results.data;
}

export default { me, update, get };
